import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    user: {},
    isAdmin: false
}

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login(state, action) {
            state.user.externalId = action.payload.externalId;
            state.user.firstName = action.payload.firstName;
            state.user.id = action.payload.id;
            state.user.isSupervisor = action.payload.isSupervisor;
            state.user.lastName = action.payload.lastName;
            state.user.profileImage = action.payload.profileImage;
            state.isAuthenticated = true;
            state.fetchAuthFinish = true;
        },
        logout(state) {
            state.user = {};
            state.isAuthenticated = false;
        },
        setInitial(state, action) {
            let userObj = Object.assign({}, ...action.payload.claims.map(x => { return { [x.type]: x.value } }));
            userObj.class = userObj.studentkita ? Number(userObj.studentkita) : null;
            userObj.ordinal = userObj.studentmakbila ? Number(userObj.studentmakbila) : null;
            state.user = { ...state.user, ...userObj };
            state.isAdmin = action.payload.user.isAdmin;
            state.isAuthenticated = action.payload.isAuth;
            state.user.isStudent = state.user.isstudent === "Yes";
        }
    }
})

export const authActions = authSlice.actions;
export default authSlice
